import React from 'react';
import { styled, CountdownText } from '@teko/ui';
import { ClockAlternativeOutlined } from '@teko/ds-icon';

const TimeMessageWrapper = styled.div `
  color: white;
  text-transform: initial;
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
`;
const BoldWrapper = styled.span `
  font-weight: bold;
`;
const LargeTextWrapper = styled.span `
  margin-right: 4px;
`;
const StyledClockOutline = styled(ClockAlternativeOutlined) `
  margin-bottom: 2px;
`;
const FlashSaleBadgeTime = ({ size, endAt }) => {
    return (React.createElement(TimeMessageWrapper, null,
        size == 'lg' && (React.createElement(LargeTextWrapper, null,
            React.createElement(StyledClockOutline, { color: "#ffffff", size: 20 }))),
        React.createElement(BoldWrapper, null,
            React.createElement(CountdownText, { date: endAt }))));
};

export { FlashSaleBadgeTime };
